import * as Table from '../Table';
import styles from './styles/Draggable.module.css';
import { Checkbox } from '../presentation';

type Props = {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checkedColor?: string;
};

export const Cell = (props: Props) => {
  return (
    <Table.Body.TD className={styles.summary}>
      <Checkbox checked={props.checked} onChange={props.onChange} checkedColor={props.checkedColor} />
    </Table.Body.TD>
  );
};

Cell.displayName = 'Column.Summary.Cell';

export const Header = (props: unknown) => {
  return <Table.Header.TH className={styles.summary}>Include Summary</Table.Header.TH>;
};

Header.displayName = 'Column.Summary.Header';
